import { render } from "./App.vue?vue&type=template&id=57c90a02"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57c90a02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57c90a02', __exports__)) {
    console.log('reload')
    api.reload('57c90a02', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=57c90a02", () => {
    console.log('re-render')
    api.rerender('57c90a02', render)
  })

}


export default __exports__